import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  DefaultOptions,
  InMemoryCache,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { NOT_AUTHENTICATED } from 'constants/apollo';
import { cache } from '../test/cache';

import React from 'react';
import { getCookie } from 'utils/Cookies';
import { routes, isNonAuthRoute } from 'routes';
import { showGraphqlSupportSnackbar } from 'utils/graphqlErrors';

export const ApolloWrapper = (props: {
  graphqlUrl: string;
  useReactiveVars?: boolean;
  children: any;
}) => {
  const { graphqlUrl, useReactiveVars } = props;

  // Cache is disabled because it hangs the app on multiple calls to changeFundInvestment.
  // The error seems to have something with the DNS resolution
  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  };

  const httpLink = createHttpLink({
    uri: graphqlUrl,
    credentials: 'include',
  });
  const authLink = setContext((context) => {
    return {
      headers: {
        // @ts-ignore
        ...context.headers,
        'X-CSRFToken': getCookie('csrftoken'),
        authorization: window.GLOBAL_CONFIG.SESSION,
      },
    };
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    // @ts-ignore
    if (networkError && [401, 403].includes(networkError.statusCode)) {

      console.log(`[Network error]: ${networkError}`);
      checkAndRedirectToLogin()
      return;
    }
    if (graphQLErrors) {
      const authError = graphQLErrors.filter(
        (e) => e?.extensions?.reason === NOT_AUTHENTICATED,
      );
      if (authError && authError.length > 0 && !isNonAuthRoute()) {

        checkAndRedirectToLogin()
        return;
      }

      graphQLErrors.map(({ message, locations, path }) =>
        console.log(
          `[GraphQL error]: Message:`,
          message,
          `Location: `,
          locations,
          ` Path: ${path}`,
        ),
      );
      if (networkError) console.log(`[Network error]: ${networkError}`);
      showGraphqlSupportSnackbar();
      return;
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
      showGraphqlSupportSnackbar();
    }
  });

  const client = new ApolloClient({
    credentials: 'include',
    link: errorLink.concat(authLink).concat(httpLink),
    cache: useReactiveVars ? cache : new InMemoryCache(),
    defaultOptions: (!useReactiveVars && defaultOptions) || undefined,
  });

  return <ApolloProvider client={client}>{props.children}</ApolloProvider>;
};


/**
 * If currently not in login page, then redirects to the same.
 * Used when authentication fails from backend.
 */
const checkAndRedirectToLogin = () => {

  if (window.location.pathname !== routes.LOGIN) {
    // @ts-ignore
    window.location = routes.LOGIN;
  }

}